import type { ChangeEvent, ReactNode, Ref } from 'react';

type SelectAllConfig = {
  id: string;
  inputRef: Ref<HTMLInputElement>;
  checked: boolean;
  disabled: boolean;
  label: string;
  onChange: () => void;
};

type WizardChecklistPanelProps = {
  panelAriaLabel: string;
  searchValue: string;
  searchPlaceholder: string;
  searchAriaLabel: string;
  onSearchChange: (value: string) => void;
  showSearch?: boolean;
  listAriaLabel: string;
  statusSlot?: ReactNode;
  selectAll?: SelectAllConfig;
  footer?: ReactNode;
  /** When true, `emptyState` is shown instead of the list (e.g. no search matches). */
  listEmpty?: boolean;
  emptyState?: ReactNode;
  children: ReactNode;
};

export const WizardChecklistPanel = ({
  panelAriaLabel,
  searchValue,
  searchPlaceholder,
  searchAriaLabel,
  onSearchChange,
  showSearch = true,
  listAriaLabel,
  statusSlot,
  selectAll,
  footer,
  listEmpty = false,
  emptyState,
  children,
}: WizardChecklistPanelProps) => (
  <div className="import-wizard__panel" aria-label={panelAriaLabel}>
    {showSearch ? (
      <div className="form-actions">
        <input
          type="search"
          value={searchValue}
          onChange={(event: ChangeEvent<HTMLInputElement>) => {
            onSearchChange(event.currentTarget.value);
          }}
          placeholder={searchPlaceholder}
          aria-label={searchAriaLabel}
        />
      </div>
    ) : null}
    {statusSlot}
    {selectAll !== undefined ? (
      <div className="checkbox-container">
        <input
          ref={selectAll.inputRef}
          id={selectAll.id}
          type="checkbox"
          checked={selectAll.checked}
          disabled={selectAll.disabled}
          onChange={selectAll.onChange}
        />
        <label htmlFor={selectAll.id}>{selectAll.label}</label>
      </div>
    ) : null}
    {listEmpty && emptyState !== undefined ? (
      emptyState
    ) : (
      <ul className="import-wizard__fields" aria-label={listAriaLabel}>
        {children}
      </ul>
    )}
    {footer}
  </div>
);
